import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CompCTA() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 200 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 350 });
  const { ref: btnsRef, revealed: btnsRevealed } = useScrollReveal({ delay: 500 });

  return (
    <section id="comp-cta" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="rounded-2xl bg-background-100 border border-background-200 p-8 md:p-12 lg:p-16 text-center relative overflow-hidden">
          <div
            className="absolute -top-20 -right-20 w-64 h-64 rounded-full blur-3xl pointer-events-none"
            style={{ background: 'oklch(var(--primary-500) / 0.08)' }}
          />
          <div
            className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full blur-3xl pointer-events-none"
            style={{ background: 'oklch(var(--primary-500) / 0.06)' }}
          />

          <div className="relative z-10 max-w-[640px] mx-auto">
            <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
              Начните сейчас
            </span>
            <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
              Готовы перехватить
              <br />
              клиентов конкурентов?
            </h2>
            <p ref={descRef} className={`mt-4 text-[14.5px] text-foreground-500 leading-relaxed reveal-fade-up ${descRevealed ? 'revealed' : ''}`}>
              Подключите перехват AIGAM и получайте горячих клиентов, которые уже готовы купить — просто у ваших конкурентов, а не у вас.
            </p>

            <div ref={btnsRef} className={`mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 reveal-fade-up ${btnsRevealed ? 'revealed' : ''}`}>
              <a
                href="https://t.me/anna_aigam"
                target="_blank"
                rel="noopener noreferrer"
                className="h-12 px-7 inline-flex items-center justify-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[15px] font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Написать в Telegram
              </a>
              <a
                href="#comp-pricing"
                className="h-12 px-6 inline-flex items-center justify-center rounded-md border border-background-200 hover:border-background-300 hover:bg-background-100 text-foreground-700 text-[15px] font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                Смотреть тарифы
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}